var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"/map/admin/factories"}},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",value:('SITE Dashboard'),expression:"'SITE Dashboard'",modifiers:{"hover":true,"right":true}}],staticClass:"admin"})])
}
var staticRenderFns = []

export { render, staticRenderFns }